















import {Vue, Component} from 'vue-property-decorator';
import Application from "@/state/Application";
import ServiceOrchestrator from "@/services/ServiceOrchestrator";
import {ServiceDTO, ServiceFilter} from "@/components/payroll/business/services/ServiceDTO";
import Page from "@/dto/taxation/Page";
import {processError} from "@/utils/ComponentUtils";
import ServiceItem from "@/components/payroll/business/services/ServiceItem.vue";

@Component({
	components: {ServiceItem}
})
export default class ServiceList extends Vue {

	private filter = new ServiceFilter(
		{
			holderId: this.$wss.getCurrent.id
		}
	)

	private page: Page<ServiceDTO> | null = null

	private showModal() {
		console.log("")
	}

	mounted() {
		this.loadServices()
	}

	private loadServices(): void {
		Application.startLoading()
		ServiceOrchestrator.getPageByFilter(this.filter).then(
			page => {
				this.page = page.data;
				Application.stopLoading()
			},
			err => processError(err, this)
		)
	}

}
